import { Component } from '@angular/core';
import { APIService } from './API.service';
import { Router } from '@angular/router';
import * as EmailValidator from 'email-validator';
import { v4 as uuidv4 } from 'uuid';
import { CalendarView, CalendarMonthViewDay } from 'angular-calendar';
import { subMonths, addMonths, addDays, addWeeks, subDays, subWeeks, startOfMonth, endOfMonth, startOfWeek, endOfWeek, startOfDay, endOfDay } from 'date-fns';
import { LAMBDA_URL, LAMBDA_API_KEY } from '../environments/environment';
import { Injectable } from "@angular/core";
import { Http, RequestOptions, Headers, } from '@angular/http';
import { Observable } from 'rxjs';

type CalendarPeriod = 'day' | 'week' | 'month';

function addPeriod(period: CalendarPeriod, date: Date, amount: number): Date {
  return {
    day: addDays,
    week: addWeeks,
    month: addMonths
  }[period](date, amount);
}

function subPeriod(period: CalendarPeriod, date: Date, amount: number): Date {
  return {
    day: subDays,
    week: subWeeks,
    month: subMonths
  }[period](date, amount);
}

function startOfPeriod(period: CalendarPeriod, date: Date): Date {
  return {
    day: startOfDay,
    week: startOfWeek,
    month: startOfMonth
  }[period](date);
}

function endOfPeriod(period: CalendarPeriod, date: Date): Date {
  return {
    day: endOfDay,
    week: endOfWeek,
    month: endOfMonth
  }[period](date);
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'combackcpapp';
  url = '';
  public email = '';
  public request_id = '';
  public form_request_id = '';
  public lastname = '';
  public name = '';
  public klastname = '';
  public kname = '';
  public birth = '';
  public epost = '';
  public error = '';
  private finished: Map<string, boolean> = new Map<string, boolean>();
  private uuidTime: Map<string, string> = new Map<string, string>();
  public checkNext = false;
  private memberList: any;
  public shops = [];
  public allList = [];
  public clubCds: string[] = [];
  public memberNos: string[] = [];
  count = 0;
  public startDate: any;
  public club_cd = '';
  public expired_date: any;
  options: Headers;
  headers: Headers;
  public check_next = false;

  view: CalendarView | CalendarPeriod = CalendarView.Month;
  CalendarView = CalendarView;
  viewDate: Date = new Date();
  // minDate: Date = subMonths(new Date(), 0);
  minDate: Date = subDays(new Date(), 0);
  maxDate: Date = addMonths(new Date(), 1);  
  prevBtnDisabled: boolean = false;
  nextBtnDisabled: boolean = false;
  activeDayIsOpen: boolean = false;
  locale: string = 'ja';

  constructor(private apiService: APIService,
    private http: Http,
    private router: Router) {
      this.url = window.location.href;
  }

  ngOnInit() {
    const date = new Date();
    let now = date.getFullYear().toString() + '' +
    ('0' + (date.getMonth() + 1).toString()).slice(-2) + '' +
    ('0' + date.getDate().toString()).slice(-2);    
    let month = this.maxDate.getMonth() + 1;
    let day = 0;
    if(month == 3 || month == 5 || month == 7 || month == 8 || month == 10 || month == 12) {
      day = 31 - this.maxDate.getDate();
    } else {
      day = 30 - this.maxDate.getDate();
    }
    this.maxDate = subDays(this.maxDate, day*(-1));
    let mmonth = this.viewDate.getMonth() + 1;
    if(mmonth == 3 || mmonth == 5 || mmonth == 7 || mmonth == 8 || mmonth == 10 || mmonth == 12) {
      if(this.viewDate.getDate() == 31) {
        this.viewDate = new Date(this.maxDate.getFullYear().toString() + '-' +
        ('0' + (this.maxDate.getMonth() + 1).toString()).slice(-2) + '-01');
        this.maxDate = addMonths(this.maxDate, 1);
        month = this.maxDate.getMonth() + 1;
        if(month == 3 || month == 5 || month == 7 || month == 8 || month == 10 || month == 12) {
          day = 31 - this.maxDate.getDate();
        } else {
          day = 30 - this.maxDate.getDate();
        }
        this.maxDate = subDays(this.maxDate, day*(-1));
      }
    } else {
      if(this.viewDate.getDate() == 30) {
        this.viewDate = new Date(this.maxDate.getFullYear().toString() + '-' +
        ('0' + (this.maxDate.getMonth() + 1).toString()).slice(-2) + '-01');
        this.maxDate = addMonths(this.maxDate, 1);
        month = this.maxDate.getMonth() + 1;
        if(month == 3 || month == 5 || month == 7 || month == 8 || month == 10 || month == 12) {
          day = 31 - this.maxDate.getDate();
        } else {
          day = 30 - this.maxDate.getDate();
        }
        this.maxDate = subDays(this.maxDate, day*(-1));
      }
    }
    if(now < '20200701') {
      if(/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        var inputs = document.getElementsByTagName("input");
        for(let i=0;i<inputs.length;i++) {
          inputs[i].style.width = "calc(100% - 25px)";
        }
      }
      if (this.url.toString().indexOf("?") > 0) {
        if(this.url.toString().indexOf('id=') > -1) {
          if(this.url.toString().indexOf('id=') > -1) {
            this.form_request_id = this.url.toString().substring(this.url.toString().lastIndexOf('=') + 1);
          }
          if(this.form_request_id != '') {
            this.apiService.GetRequestRecord(this.form_request_id).then(res => {
              let mail = res.mail_address;
              this.expired_date = res.expiry_time;
              let oldDate = new Date(res.expiry_time).getTime();
              let newDate = new Date().getTime();
              const diffInMs = newDate - oldDate;
              let minut = diffInMs/60000;
              if(minut >= 20) {
                document.getElementById('main9').style.display = 'block';
                return;
              }
              this.apiService.SelectMailWithdrew(mail).then(res2 => {
                this.memberList = res2;
                let list = [];
                list = this.memberList;
                if(list.length > 0) {
                  if(list.length == 1) {
                    this.lastname = list[0].surname_cc;
                    this.name = list[0].firstname_cc;
                    this.klastname = list[0].surname_js;
                    this.kname = list[0].firstname_js;
                    this.birth = list[0].birthday;
                    this.epost = list[0].post_no;
                  } else {
                    let check = true;
                    for(let i = 0; i < list.length - 1; i++) {
                      if(list[i].surname_cc != list[i+1].surname_cc) {
                        check = false;
                      }
                      if(list[i].firstname_cc != list[i+1].firstname_cc) {
                        check = false;
                      }
                      if(list[i].surname_js != list[i+1].surname_js) {
                        check = false;
                      }
                      if(list[i].firstname_js != list[i+1].firstname_js) {
                        check = false;
                      }
                      if(list[i].birthday != list[i+1].birthday) {
                        check = false;
                      }
                      if(list[i].post_no != list[i+1].post_no) {
                        check = false;
                      }
                    }
                    if(check) {
                      this.lastname = list[0].surname_cc;
                      this.name = list[0].firstname_cc;
                      this.klastname = list[0].surname_js;
                      this.kname = list[0].firstname_js;
                      this.birth = list[0].birthday;
                      this.epost = list[0].post_no;
                    }
                  }
                }
                document.getElementById('main4').style.display = 'block';
              });
            }, error => {
              document.getElementById('main8').style.display = 'block';
            });
          } else {
            document.getElementById('main8').style.display = 'block';
          }        
        } else if(this.url.toString().indexOf('ciN8a5MUDeYtqJrsO27s03cCoFHRuL2A=') > -1) {
          let splitURL = this.url.toString().split("?");
          let splitParams = splitURL[1].split("&");
          let singleURLParam = splitParams[0].split('=');
          if(singleURLParam[1] == 'Pd8o0YNuzfTZM74eB8tRXwEnkaupKAgf') {
            if(splitParams.length > 1) {
              if(this.url.toString().indexOf('club_cd=') > -1) {
                this.club_cd = this.url.toString().substring(this.url.toString().lastIndexOf('=') + 1);
              }
            }
            if(this.club_cd == '') {
              this.apiService.SelectWithdrewAll().then(res => {
                this.allList = res;
              });
            } else {
              this.apiService.SelectWithdrewAllByClub(this.club_cd).then(res => {
                this.allList = res;
              });
            }
            document.getElementById('main7').style.display = 'block';
          } else {
            document.getElementById('main8').style.display = 'block';
          }
        } else {
          document.getElementById('main8').style.display = 'block';
        }
      } else {
        document.getElementById('main1').style.display = 'block';
      }
    } else {
      document.getElementById('main8').style.display = 'block';
    }
  }

  onPress() {
    this.error = '';
  }  

  sendEmail(uuid: any, email: any): Observable<any> {
    this.headers = new Headers({
        'Content-Type': 'application/json',
        // 'Access-Control-Allow-Origin': '*',
        // 'Access-Control-Allow-Credentials': true,
        'x-api-key': LAMBDA_API_KEY
    });
    const headers = new Headers(this.headers);
    return this.http.post(LAMBDA_URL, {request_id: uuid, mail_address: email}, { headers: headers, body: {request_id: uuid, mail_address: email} });
  }

  getEmail() {
    if(!this.check_next) {
      if(this.email == '') {
        this.error = '正しいメールアドレスを⼊⼒してください。';
        return;
      }
      if(!EmailValidator.validate(this.email)) {
        this.error = '正しいメールアドレスを⼊⼒してください。';
        return;
      }
      this.request_id = uuidv4();
      /*this.apiService.PutRequestRecordUuid(this.request_id, this.email).then((res) => {
        if(res == null) {
          this.error = 'メール送信できませんでした。再度送信してください。';
        } else {
          document.getElementById('main2').style.display = 'none';
          document.getElementById('main3').style.display = 'block';
        }
      });*/
      this.check_next = true;
      this.sendEmail(this.request_id, this.email).subscribe((res) => {
        this.check_next = false;
        if(res == null) {
          this.error = 'メール送信できませんでした。再度送信してください。';
        } else {
          document.getElementById('main2').style.display = 'none';
          document.getElementById('main3').style.display = 'block';
        }
      }, error => {
        this.error = 'メール送信できませんでした。再度送信してください。';
      });
    }
  }

  confirmChange(club_cd: any, member_no: any, i: any) {
    this.error = '';
    if (
      this.finished[club_cd]
    ) {
      this.count++;
      this.clubCds.push(club_cd);
      this.memberNos.push(member_no);
    } else {
      if(this.count > 0) {
        this.count--;
      }
      for(let j = 0;j < this.clubCds.length;j++) {
        if(this.shops[i].club_cd == this.clubCds[j]) {
          this.clubCds.splice(j, 1);
          this.memberNos.splice(j, 1);
          j--;
        }
      }
    }
    if(this.count == 0) {
      this.checkNext = false;
    } else {
      this.checkNext = true;
    }
  }

  hasKanji(str: any) {
    return (window as any).hasKanji(str);
  }

  goNext() {
    this.error = '';
    let uuid = uuidv4();
    this.apiService.PutRequestRecordUuidEmptyMail(uuid).then((res) => {
      if(res == null) {
        this.error = 'メール送信できませんでした。再度送信してください。';
      } else {
        window.location.href = this.url.toString().substring(0, this.url.toString().length - 1) + '?id=' + uuid;
      }
    }, error => {
      this.error = '操作中にエラーが発生しました。もう一度やり直してください。';
    }); 
  }

  goBack() {
    window.location.href = this.url.toString().substring(0, this.url.toString().indexOf('?id='));
    // document.getElementById('main1').style.display = 'block';
    // document.getElementById('main4').style.display = 'none';
    // document.getElementById('main5').style.display = 'none';
  }

  next(id: any) {
    this.error = '';
    if(id == 1) {
      document.getElementById('main1').style.display = 'none';
      document.getElementById('main2').style.display = 'block';
    } else if(id == 2) {
      document.getElementById('main2').style.display = 'none';
      document.getElementById('main3').style.display = 'block';
    } else if(id == 3) {
      document.getElementById('main2').style.display = 'none';
      document.getElementById('main3').style.display = 'none';
      document.getElementById('main5').style.display = 'none';
      let oldDate = new Date(this.expired_date).getTime();
      let newDate = new Date().getTime();
      const diffInMs = newDate - oldDate;
      let minut = diffInMs/60000;
      if(minut >= 20) {
        document.getElementById('main9').style.display = 'block';
        return;
      }      
      document.getElementById('main4').style.display = 'block';
    } else if(id == 4) {
      if(this.lastname == '' || this.name == '' || this.klastname == '' || this.kname == '' || this.birth == '' || this.epost == '') {
        this.error = '入力されていない項目があります。';
        return;
      }
      if(!this.hasKanji(this.klastname)) {
        this.error = 'お名前（全⻆カタカナ）に全⻆カタカナ以外が⼊⼒されています。';
        return;
      }
      if(!this.hasKanji(this.kname)) {
        this.error = 'お名前（全⻆カタカナ）に全⻆カタカナ以外が⼊⼒されています。';
        return;
      }
      if(this.birth.length != 8) {
        this.error = '⽣年⽉⽇が間違っています。';
        return;
      }
      if(!(window as any).isValidDate(this.birth.substring(0,4) + '-' + this.birth.substring(4,6) + '-' + this.birth.substring(6,8))) {
        this.error = '⽣年⽉⽇が間違っています。';
        return;
      }
      if(this.epost.length != 7) {
        this.error = '郵便番号が間違っています。';
        return;
      }
      this.error = '';
      document.getElementById('main4').style.display = 'none';
      let oldDate = new Date(this.expired_date).getTime();
      let newDate = new Date().getTime();
      const diffInMs = newDate - oldDate;
      let minut = diffInMs/60000;
      if(minut >= 20) {
        document.getElementById('main9').style.display = 'block';
        return;
      }      
      document.getElementById('main5').style.display = 'block';
      this.dateOrViewChanged();      
      this.apiService.SelectWithdrew(this.lastname, this.name, this.klastname, this.kname, this.birth, this.epost).then(res => {
        if(res.length == 0) {
          this.error = 'お客様の退会情報が見つかりません。\r\n';
          this.error = this.error + '戻るボタンで、入力されたお客様情報をご確認ください。\r\n';
          this.error = this.error + 'それでも見つからない場合は、退会お手続きを行った店舗まで\r\n';
          this.error = this.error + 'お問い合わせください。';
        } else {
          this.shops = res;
          for(let j = 0;j < this.shops.length;j++) {
            if(this.shops[j].resume_flag) {
              if(this.shops[j].processed_flag == "true") {
                this.finished[this.shops[j].club_cd] = true;
              }
            } else {
              if(this.shops[j].processed_flag == "true") {
                this.finished[this.shops[j].club_cd] = true;
              }
            }
          }
        }
      });      
    } else if(id == 5) {
      let oldDate = new Date(this.expired_date).getTime();
      let newDate = new Date().getTime();
      const diffInMs = newDate - oldDate;
      let minut = diffInMs/60000;
      if(minut >= 20) {
        document.getElementById('main5').style.display = 'none';
        document.getElementById('main9').style.display = 'block';
        return;
      }
      const dateNow = new Date();
      let nowOrig = dateNow.getFullYear().toString() + '/' +
      ('0' + (dateNow.getMonth() + 1).toString()).slice(-2) + '/' +
      ('0' + dateNow.getDate().toString()).slice(-2) + ' 00:00:00';
      if(this.startDate <= nowOrig) {
        this.error = '利用開始日を選択し直してください。';
        return;
      }
      if(this.clubCds.length == 0) {
        this.error = '復会先店舗を選んでください。';
        return;
      }
      if(this.startDate == null) {
        this.error = '開始日を選択してください。';
        return;
      }
      const date = new Date();
      let hour,minute,second;
      if(date.getHours() < 10) {
        hour = '0' + date.getHours();
      } else {
        hour = date.getHours();
      }
      if(date.getMinutes() < 10) {
        minute = '0' + date.getMinutes();
      } else {
        minute = date.getMinutes();
      }
      if(date.getSeconds() < 10) {
        second = '0' + date.getSeconds();
      } else {
        second = date.getSeconds();
      }
      let now = date.getFullYear().toString() + '/' +
      ('0' + (date.getMonth() + 1).toString()).slice(-2) + '/' +
      ('0' + date.getDate().toString()).slice(-2) + ' ' + hour + ':' + minute + ':' + second;
      this.apiService.UpdateWithdrewList(this.form_request_id, this.memberNos, this.clubCds, true, now, this.startDate).then(res => {
        if(res.length == 0) {
          this.error = '復会申請が完了できませんでした。再度申請してください。';
        } else {
          document.getElementById('main5').style.display = 'none';
          document.getElementById('main6').style.display = 'block';
        }
      }, error => {
        this.error = '復会申請が完了できませんでした。再度申請してください。';
      });
    }
  }

  increment(): void {
    if(this.activeDayIsOpen) {
      this.activeDayIsOpen = false;
    } else {
      // this.activeDayIsOpen = true;
    }
    this.changeDate(addPeriod(this.view, this.viewDate, 1));    
  }

  decrement(): void {
    if(this.activeDayIsOpen) {
      this.activeDayIsOpen = false;
    } else {
      // this.activeDayIsOpen = true;
    }
    this.changeDate(subPeriod(this.view, this.viewDate, 1));
  }

  dateIsValid(date: Date): boolean {
    return date >= this.minDate && date <= this.maxDate;
  }

  changeDate(date: Date): void {
    this.viewDate = date;
    this.dateOrViewChanged();
  }

  dateOrViewChanged(): void {
    this.prevBtnDisabled = !this.dateIsValid(
      endOfPeriod(this.view, subPeriod(this.view, this.viewDate, 1))
    );
    this.nextBtnDisabled = !this.dateIsValid(
      startOfPeriod(this.view, addPeriod(this.view, this.viewDate, 1))
    );
    if (this.viewDate < this.minDate) {
      this.changeDate(this.minDate);
    } else if (this.viewDate > this.maxDate) {
      this.changeDate(this.maxDate);
    }
  }

  beforeMonthViewRender({ body }: { body: CalendarMonthViewDay[] }): void {
    body.forEach(day => {
      if (!this.dateIsValid(day.date)) {
        day.cssClass = 'cal-disabled';
      }
    });
  }

  dayClicked({ date }: { date: Date }): void {
    this.activeDayIsOpen = true;
    this.error = '';
    this.viewDate = date;
    this.startDate = date.getFullYear().toString() + '/' +
    ('0' + (date.getMonth() + 1).toString()).slice(-2) + '/' +
    ('0' + date.getDate().toString()).slice(-2) + ' 00:00:00';    
  }

  closeOpenMonthViewDay() {
    this.activeDayIsOpen = false;
  }
}
